let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

(() => {
  if (window.__spiritInkMpCartCleanupBound) return;
  window.__spiritInkMpCartCleanupBound = true;

  const CLEANUP_WEBHOOK = 'https://hook.eu1.make.com/qloxtb360vfg2514ryhq4lihlu1inacl';
  const PRODUCT_KEY_PROP = '_magic_preview_product_key';
  const pendingKeys = new Set();
  let cartSnapshot = null;

  const fetchCart = async () => {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });
    if (!response.ok) throw new Error(`cart.js ${response.status}`);
    return response.json();
  };

  const refreshSnapshot = async () => {
    try {
      cartSnapshot = await fetchCart();
      return cartSnapshot;
    } catch (_) {
      return null;
    }
  };

  const productKeyForIndex = (index) => {
    const item = cartSnapshot?.items?.[Number(index) - 1];
    const key = item?.properties?.[PRODUCT_KEY_PROP];
    return typeof key === 'string' && /^mp_[a-f0-9]{64}$/i.test(key) ? key : '';
  };

  const requestCleanup = (key) => {
    try {
      fetch(CLEANUP_WEBHOOK, {
        method: 'POST',
        mode: 'cors',
        keepalive: true,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        body: new URLSearchParams({ magic_preview_product_key: key }).toString(),
      }).catch(() => {});
    } catch (_) {}
  };

  document.addEventListener(
    'click',
    (event) => {
      const removeButton = event.target.closest?.('cart-remove-button');
      if (!removeButton) return;
      const key = productKeyForIndex(removeButton.dataset.index);
      if (key) pendingKeys.add(key);
    },
    true,
  );

  subscribe(PUB_SUB_EVENTS.cartUpdate, async () => {
    const cart = await refreshSnapshot();
    if (!cart || !pendingKeys.size) return;

    const keysStillInCart = new Set(
      cart.items
        .map((item) => item?.properties?.[PRODUCT_KEY_PROP])
        .filter((key) => typeof key === 'string' && key),
    );

    for (const key of [...pendingKeys]) {
      if (!keysStillInCart.has(key)) requestCleanup(key);
      pendingKeys.delete(key);
    }
  });

  refreshSnapshot();
})();
